import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('framework-asset-preview-lib', {
  library: 'framework-asset-preview-lib'
});